import { IThirdPartyApiKey } from "api/queries/apiKeysAPI";

/** Column ids for the API-key table — maps to the key fields (house convention: id enum). */
export enum ApiKeyTableColumnsIdEnum {
    LABEL = "label",
    KEY_PREFIX = "key_prefix",
    CREATED_AT = "created_at",
    EXPIRES_AT = "expires_at",
    LAST_USED_AT = "last_used_at",
    STATUS = "status",
    ACTIONS = "actions",
}

export interface IUseApiKeyColumnsParams {
    canGenerate: boolean;
    canRevoke: boolean;
    onRevoke: (row: IThirdPartyApiKey) => void;
    onRotate: (row: IThirdPartyApiKey) => void;
}
